export const ageingRowMapping_ForwardLeg = [
  {
    "Section" : "Inbound",
    "Subsections" : ["Manifested", "In Transit (DS -> DS)", "In Transit (FC -> DS)", "Arrived"]
  },
  {
    "Section" : "Induct",
    "Subsections" : ["Received (DS -> Customer)", "Inducted", "Marked for Reprocess"]
  },
  {
    "Section" : "Stow",
    "Subsections" : ["Stowed"]

  },
  {
    "Section" : "Pick and Stage",
    "Subsections" : ["Picked", "Staged (DS -> Customer)"]

  }, 
  {
    "Section" : "On Road",
    "Subsections" : ["In Transit (DS -> Customer)", "Delivery Failed", "Delivery Rejected", "Drop Failed"]

  },
  {
    "Section" : "Retained",
    "Subsections" : [{"Section": "Held", "Subsections":["Held", "FDD", "Wrong Cycle Induct", "Sidelined Closed", "Pending Customer Feedback"]},"Staged (DS -> DS)", "Problem Solve", "Rescheduled", "Customer Notes Updated"]

  },
  {
    "Section" : "Marked as Missing",
    "Subsections" : []
  },
  {
    "Section" : "Stow Buffered",
    "Subsections" : []
  },
  {
    "Section" : "Jackpot Buffered",
    "Subsections" : []
  },
  {
    "Section" : "Marked as Lost",
    "Subsections" : []
  },
  {
    "Section" : "Cash With Associate",
    "Subsections" : []
  }
]

export const ageingRowMapping_ForwardLeg_DsView = [
  {
    "Section" : "Inbound",
    "Subsections" : ["Manifested", "In Transit (DS -> DS)", "In Transit (FC -> DS)", "Arrived"]
  },
  {
    "Section" : "Induct",
    "Subsections" : ["Received (DS -> Customer)", "Inducted", "Marked for Reprocess"]
  },
  {
    "Section" : "Stow",
    "Subsections" : ["Stowed"]

  },
  {
    "Section" : "Pick and Stage",
    "Subsections" : ["Picked", "Staged (DS -> Customer)"]

  }, 
  {
    "Section" : "On Road",
    "Subsections" : ["In Transit (DS -> Customer)", "In Transit (DS -> XPT)", "Delivery Failed", "Delivery Rejected", "Drop Failed"]

  },
  {
    "Section" : "Retained",
    "Subsections" : [{"Section": "Held", "Subsections":["Held", "FDD", "Wrong Cycle Induct", "Sidelined Closed", "Pending Customer Feedback"]},"Staged (DS -> DS)", "Problem Solve", "Rescheduled", "Customer Notes Updated"]

  },
  {
    "Section" : "Marked as Missing",
    "Subsections" : []
  },
  {
    "Section" : "Stow Buffered",
    "Subsections" : []
  },
  {
    "Section" : "Jackpot Buffered",
    "Subsections" : []
  },
  {
    "Section" : "Marked as Lost",
    "Subsections" : []
  },
  {
    "Section" : "Cash With Associate",
    "Subsections" : []
  }
]

export const ageingRowMapping_ForwardLeg_XptView = [
  {
    "Section" : "Inbound",
    "Subsections" : ["In Transit (DS -> XPT)", "Received (DS -> Customer)"]
  },
  {
    "Section" : "On Road",
    "Subsections" : ["In Transit (DS -> Customer)", "Delivery Failed", "Delivery Rejected", "Drop Failed"]
  }
]

export const ageingRowMapping_ReverseLeg = [
  {
    "Section" : "Inbound",
    "Subsections" : [ "Delivery Failed", "Delivery Rejected", "Manifested (Seller/Locker -> DS)", "In Transit (XPT -> DS)", "In Transit (Seller -> DS)", "In Transit (Customer/Locker -> DS)", "Cancelled Pickups",
                    "Pickup Failed"],
    },
    {
      "Section" : "Currently At Station",
      "Subsections" : ["Received (DS -> FC)", "Marked for Reprocess (DS -> FC)", "Undeliverable", "Stowed" , "In Transit (DS -> FC/Seller)"]
    },
    {
      "Section": "Delivery Cancelled",
      "Subsections": []
    }
]

export const dwellingRowMapping = [
  {
    "Section" : "Pending Receive",
    "Subsections" : ["Manifested", "In Transit (DS -> DS)", "In Transit (FC -> DS)"],
    //Package status backend is using for sending process status
    "ProcessStatus" : ""

  },
  {
    "Section" : "Pending Induct",
    "Subsections" : [ "Arrived", "Received", {"Section": "Pending Reinduct", "Subsections":[ "Pending Reinduct", "Held:Held On Ead", "Marked for Reprocess"]}, "Induct Problem Solve"],
    "ProcessStatus" : "Arrived"

  },
  {
    "Section" : "Pending Stow",
    "Subsections" : ["Inducted", "Stow Problem Solve", "Stow Buffered", "Jackpot Buffered"],
    "ProcessStatus" : "Inducted"

  },
  {
    "Section" : "Pending Depart",
    "Subsections" : ["Stowed", "Picked", "Staged (DS -> Customer)", "Pick Problem Solve"],
    "ProcessStatus" : "Staged"
  }, 
  {
    "Section" : "On Road",
    "Subsections" : ["In Transit (DS -> Customer)", "Depart Problem Solve"],
    "ProcessStatus" : ""

  },
  {
    "Section" : "Held",
    "Subsections" : [],
    "ProcessStatus" : ""
  }

]

export const dwellingRowMappingForDS = [
  {
    "Section" : "Pending Receive",
    "Subsections" : ["Manifested", "In Transit (DS -> DS)", "In Transit (FC -> DS)", "In Transit (DS -> XPT)"],
    //Package status backend is using for sending process status
    "ProcessStatus" : ""

  },
  {
    "Section" : "Pending Induct",
    "Subsections" : [ "Arrived", "Received", {"Section": "Pending Reinduct", "Subsections":[ "Pending Reinduct", "Held:Held On Ead", "Marked for Reprocess"]}, "Induct Problem Solve"],
    "ProcessStatus" : "Arrived"

  },
  {
    "Section" : "Pending Stow",
    "Subsections" : ["Inducted", "Stow Problem Solve", "Stow Buffered", "Jackpot Buffered"],
    "ProcessStatus" : "Inducted"

  },
  {
    "Section" : "Pending Depart",
    "Subsections" : ["Stowed", "Picked", "Staged (DS -> Customer)", "Pick Problem Solve"],
    "ProcessStatus" : "Staged"
  }, 
  {
    "Section" : "On Road",
    "Subsections" : ["In Transit (DS -> Customer)", "In Transit (DS -> XPT)", "Depart Problem Solve"],
    "ProcessStatus" : ""

  },
  {
    "Section" : "Held",
    "Subsections" : [],
    "ProcessStatus" : ""
  }

]

export const dwellingRowMappingForXPT = [
  {
    "Section" : "Pending Receive",
    "Subsections" : ["In Transit (DS -> XPT)"],
    //Package status backend is using for sending process status
    "ProcessStatus" : ""

  },
  {
    "Section" : "Pending Depart",
    "Subsections" : ["Received (DS -> Customer)"],
    "ProcessStatus" : "Staged"
  }, 
  {
    "Section" : "On Road",
    "Subsections" : ["In Transit (DS -> Customer)"],
    "ProcessStatus" : ""
  }
]

export const Columns = [
  "1_DAY", "2_DAY", "3_DAY", "4_DAY", "5_DAY", "TOTAL"
]

export const rtsRowMapping = [

    {
      "Section" : "Inbound",
      "Subsections" : [ "Delivery Failed", "Delivery Rejected", "Manifested", "In Transit (Seller -> DS)", "In Transit (XPT -> DS)", "In Transit (Customer/Locker -> DS)", "Delivery Cancelled", "Cancelled Pickups", "Pickup failed"],
      },
      {
        // Custody Transfer — placeholder section for statuses that require
        // upstream indexing pipeline work to populate (PTRS BTO-SSR consumer,
        // DriftService receive event split). Frontend structure is in place
        // so no additional frontend deploy is needed when backend lands.
        "Section" : "Custody Transfer",
        "Subsections" : ["Self-Serve Return (SSR)", "Associate Debrief"],
      },
      {
        "Section" : "Currently At Station",
        // Reverse Inducted rows below are placeholders for the post-induction
        // status split (IVS induct events + NOM direction). Rows render empty
        // until the indexing pipeline emits distinct post-induct statuses.
        "Subsections" : ["Received (DS -> FC)", "RTS Received (DS -> Customer)", "Marked for Reprocess (DS -> FC)", "Reverse Inducted — Reattemptable", "Reverse Inducted — Stowable", "Undeliverable", "Stowed", "Pending Verification (DS -> FC)"],
      }
]

// LEGACY mapping (pre-cleanup). Retained so rollback via
// FEATURES.IS_RTS_WATERFALL_CLEANUP_ENABLED = false restores exact pre-CR behavior:
//   - "In Transit (DS -> FC/Seller)" stays under Currently At Station
//   - "Delivery Cancelled" stays as a standalone top-level section
// RTSData.js selects between rtsRowMapping (flag ON) and rtsRowMappingLegacy (flag OFF).
export const rtsRowMappingLegacy = [
    {
      "Section" : "Inbound",
      "Subsections" : [ "Delivery Failed", "Delivery Rejected", "Manifested", "In Transit (Seller -> DS)", "In Transit (XPT -> DS)", "In Transit (Customer/Locker -> DS)", "Cancelled Pickups", "Pickup failed"],
    },
    {
      "Section" : "Currently At Station",
      "Subsections" : ["Received (DS -> FC)", "RTS Received (DS -> Customer)", "Marked for Reprocess (DS -> FC)", "Undeliverable", "Stowed", "In Transit (DS -> FC/Seller)", "Pending Verification (DS -> FC)"],
    },
    {
      "Section": "Delivery Cancelled",
      "Subsections": []
    }
]
export const PackageStateToTextMappingForXPT = {
  "DWELL": {
    "Pending Depart": {
      "Received (DS -> Customer)": "Received (XPT -> Customer)"
    },
    "On Road": {
      "In Transit (DS -> Customer)": "In Transit (XPT -> Customer)"
    }
  },
  "AGEING": {
    "Inbound": {
      "Received (DS -> Customer)": "Received (XPT -> Customer)"
    },
    "On Road": {
      "In Transit (DS -> Customer)": "In Transit (XPT -> Customer)"
    }
  }
}

export const SDDwellingRowMapping = [
  {
    "Section" : "Pending Receive",
    "Subsections" : ["Manifested", "In Transit (DS -> DS)", "In Transit (FC -> DS)"],
    //Package status backend is using for sending process status
    "ProcessStatus" : ""

  },
  {
    "Section" : "Pending Induct",
    "Subsections" : [ "Arrived", "Received", {"Section": "Pending Reinduct", "Subsections":[ "Pending Reinduct", "Held:Held On Ead", "Marked for Reprocess"]}, "Induct Problem Solve"],
    "ProcessStatus" : "Arrived"

  },
  {
    "Section" : "Pending Stow",
    "Subsections" : ["Inducted", "Stow Problem Solve", "Stow Buffered", "Jackpot Buffered"],
    "ProcessStatus" : "Inducted"

  },
  {
    "Section" : "Pending Depart",
    "Subsections" : ["Stowed", "Picked", "Staged (DS -> Customer)", "Pick Problem Solve"],
    "ProcessStatus" : "Staged"
  },
  {
    "Section" : "On Road",
    "Subsections" : ["In Transit (DS -> Customer)", "Depart Problem Solve"],
    "ProcessStatus" : ""

  },
  {
    "Section" : "Held",
    "Subsections" : [],
    "ProcessStatus" : ""
  }

]

// Tier 1 Response Mappings of Package States to Text
export const PackageStateToTextMapping = {
  "DWELL": {
    "Pending Receive": {
      "Manifested": "Manifested (FC -> DS)"
    },
    "Pending Induct": {
      "Received": "Received (DS/Store -> Customer)"
    },
    "Pending Depart": {
      "Stowed": "Stowed (DS -> Customer)"
    },
    "On Road": {
      "In Transit (DS -> Customer)" : "In Transit (DS -> Customer/Store)"
    }
  },
  "SD_DWELL": {
    "Pending Receive": {
      "Manifested": "Manifested (FC -> DS)"
    },
    "Pending Induct": {
      "Received": "Received (DS/Store -> Customer)"
    },
    "Pending Depart": {
      "Stowed": "Stowed (DS -> Customer)"
    },
    "On Road": {
      "In Transit (DS -> Customer)": "In Transit (DS -> Customer/Store)"
    }
  },
  "AGEING": {
    "Inbound": {
      "Manifested": "Manifested (FC -> DS)"
    },
    "Stow": {
      "Stowed": "Stowed (DS -> Customer)"
    },
    "Retained": {
      "Problem Solve": "Marked For Problem"
    },
    "Currently At Station": {
      "Stowed": "Stowed (DS -> FC)",
      "Marked for Reprocess": "Marked For Reprocess (DS -> FC)"
    }
  },
  "RTS": {
    "Inbound": {
      "Manifested": "Manifested (Seller/Locker -> DS)"
    },
    "Currently At Station": {
      "Stowed": "Stowed (DS -> FC)",
      "Marked for Reprocess": "Marked For Reprocess (DS -> FC)"
    }
  },
  "SEARCH": {
    "ALL": {
      "Staged": "Staged (DS -> Customer)",
      "In Transit To Ds": "In Transit (FC -> DS)",
      "Disposed": "Removed",
      "In Transit To Customer": "In Transit (DS -> Customer)",
      "In Transit Ds To Ds": "In Transit (DS -> DS)",
      "In Transit Ds To Fc": "In Transit (DS -> FC)",
      "In Transit Customer To Ds": "In Transit (Customer -> DS)",
      "In Transit Ds To Store": "In Transit (DS -> Store)",
      "Manifested": "Manifested (FC -> DS)",
      "Received Store To Customer": "Received (Store -> Customer)"
    }
  },
  "DETAIL" : {
    "ALL": {
      "Disposed": "Removed"
    }
  }
}

export const PackageStateToGenericTextMapping = {
    "AGEING": {
        "Inbound": {
            "Manifested": "Manifested (Customer/Locker -> DS)",
            "Manifested (Seller/Locker -> DS)": "Manifested (Customer/Locker -> DS)"
        },
        "Currently At Station": {
            "Received (DS -> FC)": "Received (DS -> FC/SC)",
            "In Transit (DS -> FC/Seller)": "In Transit (DS -> FC/SC)",
            "Stowed": "Stowed (DS -> FC/SC)"
        }
    },
    "RTS": {
        "Inbound": {
            "Manifested": "Manifested (Customer/Locker -> DS)",
        },
        "Currently At Station": {
            "Received (DS -> FC)": "Received (DS -> FC/SC)",
            "In Transit (DS -> FC/Seller)": "In Transit (DS -> FC/SC)",
            "Stowed": "Stowed (DS -> FC/SC)"
        }
    }
}


//Mapping Package Reasons to Translations
export const PackageReasonToTextMapping = {
  "SEARCH": {
    "ALL": {
      "Locally Disposed": "Removed- Damaged",
      "Seller Refused": "Removed- Seller Refused"
    }
  },
  "DETAIL": {
    "ALL": {
      "Locally Disposed": "Removed- Damaged",
      "Seller Refused": "Removed- Seller Refused"
    }
  },
  "HISTORY": {
    "ALL": {
      "Locally Disposed": "Removed- Damaged",
      "Seller Refused": "Removed- Seller Refused"
    }
  }
}

//Mapping from state returned in tier 2 response to Package state
export const ActualScanToPackageStateMapping = {

  "BETWEEN_STATIONS" : "In Transit (DS -> DS)",
  "SORT" : "Stowed",
  "DELIVERED" : "Delivered",
  "DELIVERY_ATTEMPTED" : "Delivery Failed",
  "REJECTED" : "Delivery Rejected",
  "DIVERT_FAILED" : "Drop Failed",
  "DIVERTED" : "Dropped",
  "SIDELINED" : "Sidelined",
  "HOLD_FOR_CUSTOMER_REQUEST" : "Held",
  "HELD": "Held",
  "MANIFEST" : "Manifested (FC -> DS)",
  "DEPART" : "In Transit (DS -> Customer)",
  "IN_TRANSIT_TO_STORE": "In Transit (DS -> Store)",
  "IN_TRANSIT_TO_ORDT": "In Transit (DS -> XPT)",
  "IN_TRANSIT": "In Transit (XPT -> DS)",
  "DROPPED_AT_STORE": "Received (Store -> Customer)",
  "UNSUCCESSFUL_AT_STORE": "Delivery Failed",
  "DROPPED_AT_ORDT": "Received (XPT -> Customer)",
  "INDUCT" : "Inducted",
  "INDUCT_PENDING" : "Induct pending",
  "LOST" : "Marked as Lost",
  "MISSING" : "Marked as Missing",
  "STOW_BUFFERED" : "Stow Buffered",
  "JACKPOT_BUFFERED": "Jackpot Buffered",
  "DELAYED_AT_STATION" : "Marked for Reprocess",
  "PICKED" : "Picked",
  "RECEIVED": "Received",
  "DELAYED" : "Pickup Failed",
  "PICKUP_FAILED" : "Pickup Failed",
  "MARKED_AS_LOST": "Marked As Lost",
  "HOLD_FOR_REDELIVERY" : "Received (DS -> Customer)",
  "READY_FOR_FC_RETURN" : "Received (DS -> FC)",
  "ARRIVED" : "Arrived",
  "READY_FOR_TRANSFER" : "Staged (DS -> DS)",
  "STAGED" : "Staged",
  "STAGE": "Staged (DS -> Customer)",
  "NEEDS_ATTENTION" : "Problem Solve",
  "PICKED_UP" : "In Transit (Seller/Locker -> DS)",
  "DEPARTED_FOR_FC" : "In Transit (DS -> FC)",
  "SORTED_FOR_FC" : "Stowed (DS -> FC)",
  "AT_WRONG_STATION" : "Problem Solve",
  "WRONG_NODE" : "Problem Solve",
  "Wrong Node" : "Problem Solve",
  "INDUCTED" : "Inducted",
  "OUT_FOR_DELIVERY" : "In Transit (DS -> Customer)",
  "PROBLEM_SOLVE" : "Problem Solve",
  "HOLD_FOR_ACTION" : "Problem Solve",
  "DEPARTED" : "In Transit (DS -> Customer)",
  "PICKUP_DONE" : "In Transit (Customer/Locker -> DS)",
  "PENDING_PICKUP" : "Manifested (Seller/Locker -> DS)",
  "PENDING_RETURN_PICKUP" : "Manifested (Customer -> DS)",
  "MANIFEST_CANCELLED": "Manifest Cancelled",
  "MFN_CANCELLED": "Manifest Cancelled",
  "MFN_PICKUP_DONE" : "In Transit (Seller -> DS)",
  "IN_TRANSIT_TO_DS" :"In Transit (FC -> DS)",
  "IN_TRANSIT_DS_TO_DS": "In Transit (DS -> DS)",
  "IN_TRANSIT_TO_CUSTOMER": "In Transit (DS -> Customer)",
  "IN_TRANSIT_DS_TO_FC": "In Transit (DS -> FC)",
  "IN_TRANSIT_CUSTOMER_TO_DS": "In Transit (Customer/Locker -> DS)",
  "CASH_IN_ASSOCIATE": "Cash In Associate",
  "RTS_RECEIVED_TO_DS": "RTS Received (DS -> Customer)",
  "DISPUTED_SCAN": "Disputed Scan",
  "PENDING_DROPOFF" : "Manifested (Seller DropOff)",
  "PENDING_VERIFICATION" : "Pending Verification (DS -> FC)"
}

/**
 * List of metrics that are conditional and should only appear in row mappings
 * if they exist in the actual metrics data
 */
export const CONDITIONAL_METRICS = [
    "Jackpot Buffered",
    "Pending Verification (DS -> FC)"
];



// WEBPACK FOOTER //
// ./src/commons/dataStore/PackageResultsData.js